import React from 'react';

import IconGithub from '../assets/icon_github.svg';
import IconTwitter from '../assets/icon_twitter.svg';
import IconInstagram from '../assets/icon_instagram.svg';
import EuclidLogo from '../assets/euclid_logo.svg';

const Footer = () => (
  <div id="footer">
    <div className="width-limit" id="footer-flex">
      <div>
        <div id="footer-icons">
          <a
            className="footer-icon"
            href="https://twitter.com/euclidxr"
            target="_blank"
            rel="noreferrer">
            <img src={IconTwitter} width={40} height={40} alt="Twitter" />
          </a>
          <a
            className="footer-icon"
            href="https://instagram.com/euclid_xr"
            target="_blank"
            rel="noreferrer">
            <img src={IconInstagram} width={40} height={40} alt="Instagram" />
          </a>
          <a
            className="footer-icon"
            href="https://github.com/euclidxr"
            target="_blank"
            rel="noreferrer">
            <img src={IconGithub} width={40} height={40} alt="Github" />
          </a>
        </div>
        <p id="footer-company">
          Built by
          <a href="https://euclidxr.com">
            <img
              src={EuclidLogo}
              width={125}
              height={40}
              alt="EuclidXR Immersive logo"
              className="logo"
            />
          </a>
        </p>
        <p id="footer-copyright">&copy; 2022 EuclidXR Immersive Pvt Ltd</p>
      </div>

      <div className="footer-links">
        {/*<a>OUR TECHNOLOGY</a>*/}
        <a href="/developers">DEVELOPER GUIDE</a>
        <a href="https://euclidxr.com/tos">TERMS AND CONDITIONS</a>
        <a href="#contact">CONTACT US</a>
      </div>
      {/*<a href="https://euclidxr.com">*/}
    </div>
  </div>
);

export default Footer;
